import { useEffect, useState } from "react"
import { subscribeRoom } from "./ballparkRoom"

export function useBallparkRoom(code) {
  const [state, setState] = useState({ room: null, loading: true, error: null })

  useEffect(() => {
    if (!code) return undefined
    setState({ room: null, loading: true, error: null })
    const unsubscribe = subscribeRoom(
      code,
      (room) =>
        setState({ room, loading: false, error: room ? null : "not-found" }),
      (err) => setState({ room: null, loading: false, error: err.code || "error" })
    )
    return unsubscribe
  }, [code])

  return state
}
